// extracted by mini-css-extract-plugin
export default {"swishCard":"swishCard__swishCard--sqbDy","swishCardTitle":"swishCard__swishCardTitle--GKQpp","markdown":"swishCard__markdown--Mjay5"};